module.exports = __webpack_public_path__ + "src/img/splash_2.77d2201d.png";